import { publicFetch } from "./fetch";
import { last } from "lodash";

export const getMailChimpContentById = async (id) => {
  const url = `${__BASE_API_URL__}/mailchimp/campaigns/${id}/content`;
  try {
    const result = publicFetch(url, {
      method: "GET",
    });
    // console.log(result);
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getMailChimpCampaign = async () => {
  const url = `${__BASE_API_URL__}/mailchimp/campaigns`;

  try {
    const result = publicFetch(url, {
      method: "GET",
    });
    // console.log(result);
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const mailChimpSignUp = async (email, firstName, lastName) => {
  const url = `${__BASE_API_URL__}/mailchimp/lists/members`;
  const body = `email=${email}&firstName=${firstName}&lastName=${lastName}`;

  try {
    const result = await fetch(url, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      body: body,
    });
    // console.log(result);
    if (result.status != 200) {
      throw "err";
    }
    return result;
  } catch (e) {
    console.error(e);
    return "err";
  }
};
